export enum ActionType {
    Add,
    Added,
    Edit,
    Updated,
    Delete,
    Deleted,
    List
}

